export const wasmFilter = {
  methods: {
    allocArray(len) {
      var ptr = this.moduleInstance._malloc(len * 4)
      return ptr
    },
    copyToArray(ptr, array) {
      this.moduleInstance.HEAPF32.set(array, ptr / 4)
    },
    ptrToArray(ptr, length) {
      var array = new Float32Array(length)
      var pos = ptr / 4
      array.set(this.moduleInstance.HEAPF32.subarray(pos, pos + length))
      return array
    },
    freeBuffer(ptr) {
      this.moduleInstance._free(ptr)
    }
  }
}
